import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'
import { fundingFont } from '../../theme/fundingTypography'

export const useStyles = makeStyles()(theme => ({
  table: {
    display: 'grid',
    gridTemplateColumns:
      'minmax(0, 1fr) minmax(0, 2fr) repeat(3, minmax(max-content, 1fr))',
    columnGap: theme.spacing(2),
  },
  tableWithScaling: {
    gridTemplateColumns:
      'min-content minmax(0, 1fr) minmax(0, 2fr) repeat(3, minmax(max-content, 1fr))',
  },
  headerRow: {
    display: 'grid',
    gridColumn: '1 / -1',
    gridTemplateColumns: 'subgrid',
    alignItems: 'end',
    padding: theme.spacing(1.25, 2),
    backgroundColor: C.programCardBg,
    borderBottom: `1px solid ${C.separator}`,
  },
  row: {
    display: 'grid',
    gridColumn: '1 / -1',
    gridTemplateColumns: 'subgrid',
    alignItems: 'start',
    padding: theme.spacing(1.5, 2),
    transition: 'background-color 0.15s ease',
    '& + &': {
      borderTop: `1px solid ${C.separator}`,
    },
    '&:hover': {
      backgroundColor: C.programCardBg,
    },
  },
  checkCell: {
    '& .MuiFormControlLabel-root': {
      margin: 0,
    },
    '& .MuiCheckbox-root': {
      margin: 0,
      padding: 0,
    },
  },
  quantityCell: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing(1),
    minWidth: 0,
  },
  quantityField: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing(0.5),
  },
  infoIcon: {
    marginLeft: theme.spacing(0.5),
    cursor: 'help',
  },
  truncated: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
    cursor: 'help',
  },
  amount: {
    justifySelf: 'end',
    textAlign: 'right' as const,
    whiteSpace: 'nowrap' as const,
  },
  struck: {
    textDecoration: 'line-through',
    color: C.mutedText,
  },
  label: {
    fontFamily: fundingFont,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    color: C.mutedText,
    margin: 0,
  },
  value: {
    margin: 0,
    fontFamily: fundingFont,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: C.darkText,
    fontVariantNumeric: 'tabular-nums',
    wordBreak: 'break-word' as const,
  },
  currency: {
    fontFamily: fundingFont,
    fontSize: 12,
    lineHeight: '16px',
    color: C.mutedText,
  },
  numberInput: {
    boxSizing: 'border-box' as const,
    width: '100%',
    height: theme.spacing(4),
    padding: theme.spacing(0, 1.25),
    border: `1px solid ${C.separator}`,
    borderRadius: 8,
    fontFamily: fundingFont,
    fontSize: 14,
    lineHeight: '20px',
    color: C.darkText,
    backgroundColor: C.cardBg,
    fontVariantNumeric: 'tabular-nums',
    MozAppearance: 'textfield' as const,
    transition: 'border-color 0.15s ease',
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      WebkitAppearance: 'none' as const,
      margin: 0,
    },
    '&:hover': {
      borderColor: C.buttonBorder,
    },
    '&:focus': {
      outline: 'none',
      borderColor: C.linkBlue,
    },
  },
  amountInput: {
    justifySelf: 'end',
    width: theme.spacing(12),
    textAlign: 'right' as const,
  },
}))
